import React from 'react';
import ContactForm from '../components/ContactForm';
import '../css/ContactPage.css';

const ContactPage = () => {
    return (
        <div className="contact-page">
            <ContactForm />
        </div>
    );
};

export default ContactPage;